import ChartDataLabels from "chartjs-plugin-datalabels";
import { SettlementMonthNetIncomeMonthResponse } from "../../../../../api/settlement-month";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  Filler
);

export const useNetIncomeChart = (
  monthList: SettlementMonthNetIncomeMonthResponse[]
) => {
  const customImage = new Image();
  customImage.src = "/image-web/dashboard/chart/pointer.svg";

  const color = () => {
    const ctx = document.getElementById("myChart") as HTMLCanvasElement | null;
    if (!ctx) return;

    const context = ctx.getContext("2d");
    if (!context) return;

    const gradient = context.createLinearGradient(0, 0, 0, 300);
    gradient.addColorStop(0, "rgba(116, 89, 217, 0.1)");
    gradient.addColorStop(1, "rgba(255, 255, 255, 0)");

    return gradient;
  };

  const labels = monthList.map((m) => `${m.month}월`);
  const netIncomes = monthList.map((m) => m.totalNetIncome);

  const chartData = {
    // X축 레이블 (월)
    labels: labels,
    datasets: [
      {
        data: netIncomes,
        // 선 색상
        borderColor: "#7459D9",
        // 배경색 그라데이션 설정
          backgroundColor: (ctx: any) => {
          const chart = ctx.chart;
          const { ctx: canvasCtx, chartArea } = chart;

          if (!chartArea) return null;

          const gradient = canvasCtx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );

          gradient.addColorStop(0, "rgba(116, 89, 217, 0.15)");
          gradient.addColorStop(1, "rgba(116, 89, 217, 0)");

          return gradient;
        },
        background: color(),
        tension: 0.4,
        pointRadius: 0,
        pointStyle: customImage,
        // 호버 인식 반경
        hitRadius: 40,
        // 차드 아래 그라데이션 시작점
        fill: "start",
        datalabels: {
          display: false, // value 숨김
        },
      },
    ],
  };

  const options = {
    responsive: true, // 반응형 설정
    maintainAspectRatio: false, // 종횡비 유지 안 함
    animator: true, // 애니메이션 사용
    plugins: {
      legend: {
        display: false, // 범례 숨김
      },
      tooltip: {
        enabled: false, // 기본 툴팁 비활성화
        external: function (tooltip: any) {
          // 커스텀 툴팁 렌더링 로직
          const tooltipEl = document.getElementById("chartjs-tooltip");
          const line = document.getElementById("line");
          if (!tooltipEl || !line) return;

          if (tooltip.tooltip.opacity === 0) {
            tooltipEl.style.opacity = "0";
            line.style.opacity = "0";
            return;
          }

          const chart = tooltip.chart;
          const tooltipDataPoint = tooltip.tooltip.dataPoints[0];
          const x = tooltipDataPoint.element.x;
          const y = tooltipDataPoint.element.y;
          const lineX = x;
          const lineY = y;
          const tooltipX = x - 135;
          const tooltipY = y - 210;
          const lineHeight = chart.scales["x"].top - y;
          const height = lineHeight;

          tooltipEl.style.opacity = "1";
          tooltipEl.style.left = tooltipX + "px";
          tooltipEl.style.top = tooltipY + "px";

          line.style.opacity = "1";
          line.style.height = height + "px";
          line.style.left = lineX + "px";
          line.style.top = lineY + "px";

          const labelList = chart.config._config.data.labels;
          const dataDate = tooltipDataPoint.label;

          const index = labelList.findIndex(
            (label: string) => label === dataDate
          );

          const netIncome = monthList[index].totalNetIncome;

          tooltipEl.innerHTML = `
            <div class="wrapper">
              <div class="header">${labels[index]}</div>
              <div class="content">
                <div class="info">
                  <div>지출</div>
                  <div class="value">${monthList[
                    index
                  ].totalExpense?.toLocaleString()}원</div>
                </div>
                <div class="info">
                  <div>매출</div>
                  <div class="value">${monthList[
                    index
                  ].totalRevenue?.toLocaleString()}원</div>
                </div>
                <div class="info">
                  <div>순이익</div>
                  <div class="value">${
                    netIncome >= 0
                      ? netIncome?.toLocaleString()
                      : `(${(netIncome * -1)?.toLocaleString()})`
                  }원</div>
                </div>
              </div>
            </div>
          `;
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true, // 0부터 시작
        ticks: {
          stepSize: 5000000, // 눈금 간격 (500만)
          color: "#A2A3A5", // 눈금 색상
          font: {
            size: 16,
            color: "#A2A3A5",
            weight: 400,
            family: "Pretendard",
          },
          padding: 15, // 패딩
        },
        border: {
          width: 0, // 테두리 두께 0
        },
      },
      x: {
        grid: {
          display: false, // 격자 숨김
        },
        ticks: {
          color: "#A2A3A5", // 눈금 색상
          padding: 10, // 패딩
          font: {
            size: 14,
            color: "#A2A3A5",
            weight: 400,
            family: "Pretendard",
          },
        },
      },
    },
  };
  return { chartData, options };
};
